module.exports = __webpack_public_path__ + "static/logo-18e1c49d3a559be241f77a2d79fcec9b.svg";